import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// [A형] ParagraphSelector/SectionSelector(2단계) → EntrySelector(한 화면 통합)로 교체.
// 두 원본 파일은 롤백 대비 레포에 보존한다.
import EntrySelector from "../features/assignment/components/common/EntrySelector";

import {
  fetchParagraphList,
  fetchSectionList,
  setParagraph,
  setSection,
  retreiveAssignment,
} from "../features/assignment/assignmentSlice";
import TopBar from "../features/assignment/components/widgets/TopBar";
import SectionPage from "../features/assignment/components/common/SectionPage";
import { checkStudent, checkUser } from "../features/student/studentSlice";
import "./StudyPage.css";

const ReviewPage = () => {
  const dispatch = useDispatch();
  const { paragraphList, sectionList } = useSelector(
    (state) => state.assignment
  );
  const [selectedParagraph, setSelectedParagraph] = useState(null);
  const [selectedSection, setSelectedSection] = useState(null);
  const [currentStep, setCurrentStep] = useState(1);
  // [레이스 수정] SPA에서 과제 A→B 연속 진입 시 redux에 A의 paragraphList가 남아
  // 있는데, EntrySelector 자동선택이 그 낡은 목록을 집어 B 화면에 A의 섹션이
  // 뜨는 버그가 있었다("내용이해 메뉴가 모의고사에 나옴"). 이번 과제의
  // fetchParagraphList가 끝난 뒤에만 진입 화면을 활성화한다.
  const [entryReady, setEntryReady] = useState(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const assignmentId = queryParams.get("id");

    const session = queryParams.get("session");
    const type = queryParams.get("type");

    if (session) {
      try {
        const decoded = atob(session);
        const [id, randomCode] = decoded.split(":");
        if (type === "student")
          dispatch(checkStudent({ studentId: id, randomCode: randomCode }));
        else dispatch(checkUser({ userId: id, randomCode: randomCode }));

        if (assignmentId) {
          try {
            dispatch(retreiveAssignment(assignmentId));
            dispatch(fetchParagraphList(assignmentId)).then(() => setEntryReady(true));
          } catch (error) {
            alert("잘못된 URL입니다.");
          }
        } else {
          alert("잘못된 URL입니다.");
        }
      } catch (error) {
        alert("잘못된 URL입니다.");
      }
    } else {
      alert("잘못된 URL입니다.");
    }
  }, [dispatch]);

  // [A형] 지문 행 클릭 = 기존 "다음" 버튼(handleCompleteParagraphSelection)의
  // 몸통(setParagraph + fetchSectionList)을 그대로 클릭 시점으로 이동.
  const handleSelectParagraph = (paragraph) => {
    setSelectedParagraph(paragraph);
    dispatch(setParagraph(paragraph));
    dispatch(fetchSectionList(paragraph.id));
  };

  // [A형] 섹션 행 클릭 = 기존 "학습하기" 버튼(handleCompleteSectionSelection)의
  // 몸통(setSection + setCurrentStep(3))을 그대로 클릭 시점으로 이동.
  const handleEnterSection = (section) => {
    dispatch(setSection(section));
    setSelectedSection(null);
    setCurrentStep(3);
  };

  const renderContent = () => {
    // [A형] step 1과 2를 모두 EntrySelector로 렌더한다.
    // 각 학습 화면은 완료 시 setCurrentStep(2)로 "섹션 선택 복귀"를 호출하는데,
    // 2를 함께 매핑하면 그 호출들이 그대로 통합 진입 화면 복귀가 되어
    // 학습 컴포넌트 수정이 0개가 된다.
    if (currentStep === 1 || currentStep === 2) {
      return (
        <EntrySelector
          entryReady={entryReady}
          paragraphList={paragraphList}
          sectionList={sectionList}
          selectedParagraph={selectedParagraph}
          onSelectParagraph={handleSelectParagraph}
          onEnterSection={handleEnterSection}
          isReview={true}
        />
      );
    }
    return <SectionPage setCurrentStep={setCurrentStep} isReview={true} />;
  };

  return (
    <div
      className="study-page"
      onContextMenu={(e) => {
        e.preventDefault();
      }}
    >
      <div className="study-page__column">
        <TopBar
          currentStep={currentStep}
          setCurrentStep={setCurrentStep}
          isReview={true}
        />
        {renderContent()}
      </div>
    </div>
  );
};

export default ReviewPage;
